var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","grid-list-lg":""}},[(_vm.loading)?_c('v-progress-linear',{staticClass:"ma-0",attrs:{"indeterminate":""}}):_vm._e(),(_vm.regionPriceLists.length > 0)?_c('v-tabs',[_vm._l((_vm.regionPriceLists),function(region){return _c('v-tab',{key:region.regionId},[_vm._v("\n\t\t\t"+_vm._s(region.regionName)+"\n\t\t")])}),_vm._l((_vm.regionPriceLists),function(region){return _c('v-tab-item',{key:region.regionId},[_c('v-data-table',{attrs:{"hide-actions":"","dense":"","headers":[
					{
						text: 'Werkstoffe',
						value: 'werkstoff',
					},
					{
						text: 'Verfügbar',
						value: 'available',
					},
				],"items":region.werkstoffe,"item-key":"werkstoff"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',[_vm._v(_vm._s(props.item.werkstoff))]),_c('td',{on:{"click":function($event){$event.stopPropagation();}}},[_c('v-checkbox',{on:{"change":function($event){return _vm.assignWerkstoffToRegion(
										region.regionId,
										props.item.werkstoff,
										props.item.available
									)}},model:{value:(props.item.available),callback:function ($$v) {_vm.$set(props.item, "available", $$v)},expression:"props.item.available"}})],1)])]}},{key:"expand",fn:function(props){return [_c('v-data-table',{staticClass:"elevation-1 ml-3 mb-3",attrs:{"headers":[
							{
								text: 'Aktiv',
								align: 'left',
								sortable: false,
								value: 'active',
							},
							{
								text: 'Fab Id',
								align: 'right',
								sortable: false,
								value: 'id',
							},
							{
								text: 'Name',
								align: 'left',
								sortable: false,
								value: 'name',
							},
							{
								text: 'Bezeichnung',
								align: 'left',
								sortable: false,
								value: 'bezeichnung',
							},
							{
								text: 'Dicke',
								align: 'right',
								sortable: false,
								value: 'thickness',
							},
							{
								text: 'Preise',
								align: 'left',
								sortable: false,
								value: 'modelPrices',
							},
						],"hide-actions":"","dense":"","items":props.item.materials,"item-key":"item.werkstoff"},scopedSlots:_vm._u([{key:"items",fn:function(position){return [_c('tr',[_c('td',{on:{"click":function($event){$event.stopPropagation();}}},[_c('v-checkbox',{on:{"change":function($event){return _vm.assignMaterialfToRegion(
												region.regionId,
												position.item.id,
												position.item.active
											)}},model:{value:(position.item.active),callback:function ($$v) {_vm.$set(position.item, "active", $$v)},expression:"position.item.active"}})],1),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(position.item.id))]),_c('td',[_vm._v(_vm._s(position.item.name))]),_c('td',[_vm._v(_vm._s(position.item.beschreibung))]),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(position.item.thickness))]),_c('td',[_c('v-layout',{staticClass:"my-2",attrs:{"column":""}},_vm._l((position.item.modelPrices),function(modelPrice){return _c('v-flex',{key:modelPrice.priceModel},[_c('v-form',{ref:"priceForm",refInFor:true,model:{value:(modelPrice.valid),callback:function ($$v) {_vm.$set(modelPrice, "valid", $$v)},expression:"modelPrice.valid"}},[_c('v-text-field',{attrs:{"label":_vm.getEnumNameFromValue(
															modelPrice.priceModel
														),"suffix":region.currency,"hide-details":"","rules":_vm.optionalNonNegativeNumberRule,"placeholder":modelPrice.priceModel == 0
															? ''
															: _vm.getPlaceholder(position.item)},on:{"keyup":function($event){modelPrice.price === null ||
														modelPrice.price.trim() === ''
															? (modelPrice.price = null)
															: {}},"change":function($event){return _vm.updateMaterial(
															position.item,
															region.regionId,
															modelPrice.valid
														)}},model:{value:(modelPrice.price),callback:function ($$v) {_vm.$set(modelPrice, "price", $$v)},expression:"modelPrice.price"}})],1)],1)}),1)],1)])]}}],null,true)})]}}],null,true)})],1)})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }